// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.packageReturn[data-v-caf68d4e] {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.packageReturnItem[data-v-caf68d4e] {\n  margin-bottom: 5px;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
